<template>
  <div class="left">
    <el-menu
      :collapse="isCollapse"
      router
      default-active="2"
      class="el-menu-vertical-demo"
      :unique-opened="true"
      >
      
      <template v-for="route in routerList" >  
        <template v-if="route.children && route.children.length && route.path != '/index' && route.path != '/user' && route.meta.roles.indexOf(rid) != -1" >  
          <el-submenu :index="route.path" :key="route.path">
             <template slot="title">
              <img :src="route.icon" class="left_icon">
              <span>{{route.name}}</span>
              </template>
              <template v-for="(item,index) in route.children"  >
                <el-menu-item v-if="!item.meta.hidden" :key="index" :index="route.path + '/' + item.path">
                  <img src="../assets/image/child_2.png" class="left_icon2">
                  <span for="">{{item.name}}</span>
                </el-menu-item>
              </template>
          </el-submenu>
        </template>  
        <template v-if="route.path === '/index'">
          <!-- <template v-if=""> -->
          <el-menu-item   :index="route.path" :key="route.path" v-if="!route.hidden">
            <img :src="route.icon" class="left_icon2">
            <span for="">{{route.name}}</span>
          </el-menu-item>
        <!-- </template> -->
        </template>
      </template>  
    </el-menu>
  </div>
</template>

<script>
export default {
  name: '',
  data(){
    return {
      show:0,
      showActive:0,
      showSecond:0,
      showThird:'',
      routerList:[],
      rid:0
    }
  },
  props:{
    isCollapse:{
      type:Boolean
    }
  },
  created(){
    this.routerList = this.$router.options.routes
    this.rid  = Number(this.$store.state.rid)
  },
  mounted(){
    
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    // width: 240px;
    min-height: 400px;
  }

 @import '../assets/scss/left.scss';
</style>
